import Heading from '../../components/atoms/Heading'
import Layout from '../../templates/Layout'
import PendingInvoicesTable from '../../templates/InvoicesTable'

const ReceivableInvoicesPage = () => {
  return (
    <Layout>
      <Heading type="1" border margin>
        Facturas Enviadas
      </Heading>
      <PendingInvoicesTable status="sent" />
    </Layout>
  )
}

export default ReceivableInvoicesPage
